// Libraries
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
// Services
import { ApiService, SettingService } from '../../common/modules/core/services';
//Models
import { EmailStudentsFilter,EmailFilter, Email } from '../models'
import { SaveEmail, SendEmail, JobSendMail } from '../models/Email'

@Injectable()
export class EmailService {
    // Api Domain Url
    private apiUrl = '';
    // Url send email
    private emailUrl = '/hol-email';
    private emaiStudentslUrl = '/hol-email-students';
    private emailSetting = '/booking-settings';
    private settingType= '/setting_type';

    constructor(
        private apiService: ApiService,
        private settingService: SettingService
    ) {
        // Get API service domain for communate.
        this.apiUrl = this.settingService.getSetting('api_service_domain');
    }

    getEmail(filter: EmailFilter): Observable<Email> {
        let requestUrl = this.apiUrl + this.emailUrl;
        let hasFilter = false;
        
        // Setup filter conditions
        for(let condition in filter) {
            if(filter[condition]) {
                if(hasFilter) {
                    requestUrl += '&';
                }
                else{
                    requestUrl += '?';
                    hasFilter = true;
                }

                requestUrl += condition + '=' + filter[condition];
            }
        }

        return this.apiService.get<Email>(requestUrl);
    }

    getEmailStudents(filter: EmailStudentsFilter): Observable<any> {
        let requestUrl = this.apiUrl + this.emaiStudentslUrl;
        let hasFilter = false;
        
        // Setup filter conditions
        for(let condition in filter) {
            if(filter[condition]) {
                if(hasFilter) {
                    requestUrl += '&';
                }
                else{
                    requestUrl += '?';
                    hasFilter = true;
                }

                requestUrl += condition + '=' + filter[condition];
            }
        }

        return this.apiService.get<Email>(requestUrl);
    }

    getEmailDetail(emailId: number): Observable<Email> {
        const requestUrl = this.apiUrl + this.emailUrl + '/' + emailId;
        return this.apiService.get<Email>(requestUrl)
    }

    sendEmail(sendEmail: SendEmail): Observable<any> {
        const requestUrl = this.apiUrl + this.emailUrl;
        // Post command
        const body = JSON.stringify(sendEmail)

        return this.apiService.post(requestUrl, body); 
    }

    updateEmail(saveEmail: SaveEmail): Observable<any> {
        const requestUrl = this.apiUrl + this.emailUrl;
        // Post command
        const body = JSON.stringify(saveEmail)

        return this.apiService.patch(requestUrl, body); 
    }

    getSettingEmail(): Observable<any> {
        const requestUrl = this.apiUrl + this.emailSetting + '?' + this.settingType + '=payment-reminder-setting';
        return this.apiService.get<Email>(requestUrl)
    }

    upsertSettingEmail(data: JobSendMail): Observable<any> {
        const requestUrl = this.apiUrl + this.emailSetting;
        const body = JSON.stringify(data);
        return this.apiService.patch(requestUrl, body); 
    }
}


// WEBPACK FOOTER //
// ./src/holiday/services/EmailService.ts